export default "__VITE_ASSET__oY5IJllJ__"